import { formatMessage } from './../i18n/translate';

const normalizeError = (error: { response: { data: { message: any; extras: any } }; message: any } | any) => {
  if (error?.response) {
    return error?.response?.data?.extras?.help || error?.response?.data?.message || formatMessage('commonErrorMessage');
  }

  return error?.message;
};

export default normalizeError;
